export const LINE_COLOR = "#db281b";
export const STAVE_DIVIDER_COLOR = "#222110";
export const NOTE_COLOR = "#222110";
export const TEXT_COLOR = "#222110";
export const HYPHEN_COLOR = "#222110";
export const DOT_COLOR = "#db281b";
export const RUBRIC_COLOR = "#db281b";
export const TUNING_HIGHLIGHT_NOTE_COLOR = "#00c3e8";
export const TUNING_HIGHLIGHT_OUTLINE_COLOR = "#007f96";

const isWindows = navigator.platform.indexOf("Win") > -1;

export const MAIN_CANVAS_FONT = "19px EB Garamond";
export const MAIN_CANVAS_FONT_SMALL = "17px EB Garamond";
export const DROP_CAP_CANVAS_FONT = "84px Goudy Initialen";

//export const PAGE_BACKGROUND = "#29261e";
export const PAGE_BACKGROUND = "#e8e8e8";
//export const BACKGROUND_COLOR = "#fffbf0";
export const BACKGROUND_COLOR = "#fafafa";
export const DARKENED_BACKGROUND_COLOR = "#f8f8f8";
export const EVEN_DARKER_BACKGROUND_COLOR = "#f4f4f4";
export const HORIZONTAL_RULE_COLOR = "#d0d0d0";
export const BUTTON_BACKGROUND_COLOR = "#dcdcdc";

export const TEXT_FONT = isWindows ? "EB Garamond" : "EB Garamond";
export const TEXT_SIZE = 19;
export const TEXT_INDENT = 48;

export const WIDTH = 680;

export const PRAY_PATH = "se";
